// Libs
import * as React from 'react';
import { useState } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

// Components
import { ToolButton } from '@ibinder/common-frontend';

// Icons
import { upload } from '@ibinder/common-icons';

const ActionbarContent = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  animation: identifier 350ms;
  margin-bottom: 1rem;
  @keyframes identifier {
    0% {
      opacity: 0;
      max-height: 0;
    }
    100% {
      opacity: 1;
      max-height: 80px;
    }
  }
`;
const StyledToolButton = styled(ToolButton)`
  align-self: flex-start;
  & > div {
    padding-right: 1rem;
  }
  div > input {
    display: none;
  }
`;

const StyledText = styled.small`
  margin-left: 1em;
`;

const UploadFileButton = ({
  setSelectedType,
  setFormCompleted,
  label = null
}) => {
  const [fileValue, setFileValue] = useState(null);
  const { t } = useTranslation();
  const inputFile = React.useRef(null);

  const onChange = async (event) => {
    const { value, files } = event.target;
    setSelectedType((prevState) => ({
      ...prevState,
      facilityFile: files[0]
    }));

    setFileValue(files[0].name);
    setFormCompleted(true);
  };

  const chooseFile = () => {
    inputFile.current.click();
  };

  return (
    <ActionbarContent>
      <StyledToolButton type="button" onClick={chooseFile}>
        {upload}
        {label ? label : t('Upload Facility File')}
        <input
          data-test="upload-file"
          name="facilityFile"
          id="remarkPhotoUploadd"
          type="file"
          ref={inputFile}
          className="custom"
          multiple={false}
          onChange={onChange}
          accept=".xlsx"
        />
      </StyledToolButton>
      {fileValue && <StyledText>{fileValue}</StyledText>}
    </ActionbarContent>
  );
};

export default UploadFileButton;
